import { useMemo } from 'react'
import { DashBoardValue } from 'features/dashBoard/hooks'
import { DashBoardItemOption } from 'features/dashBoard/types'
import { GraphOptions, getAxisDef, getValueDef } from '../../common'

import { TargetListResult } from "interface/search/targetList"

export const TreeMapGraphOptions: GraphOptions[][] = [
  [
    {
      id: 'axis',
      type: 'axis',
      label: '軸',
      suffix: 'ごとの'
    },
    {
      id: 'value',
      type: 'value',
      label: '値'
    },
    {
      id: 'formula',
      type: 'choice',
      label: '集計式',
      prefix: 'の',
      data: [
        { label: '合計', value: 'sum', showOnTitle: false },
        { label: '平均', value: 'ave' },
        { label: '最大', value: 'max' },
        { label: '最小', value: 'min' },
      ],
      default: 'sum'
    }
  ]
]

type useTreeMapGraphOptionProps<T> = {
  dashBoard: DashBoardValue<T>
  options?: DashBoardItemOption[]
  targetList?: TargetListResult
}
export const useTreeMapGraphOption = <T,>({
  dashBoard: {
    configure,
    globalAxisKey
  },
  options,
  targetList
}: useTreeMapGraphOptionProps<T>) => useMemo(
  () => ({
    configure, options, targetList,
		axisDef: getAxisDef(configure, options, 'axis', globalAxisKey, targetList),
		valueDef: getValueDef(configure, options, 'value', targetList),
		formula: options?.find((opt) => opt.id === 'formula')?.value
	}),
  [options, configure, globalAxisKey, targetList]
)
